export const colors = {
  arsenic: '#424242',
  black: '#000000',
  black900: '#1C2126',
  black800: '#2C323B',
  black700: '#3B454F',
  black600: '#4C5763',
  black500: '#667380',
  black400: '#84919E',
  black300: '#AAB6C2',
  black200: '#BEC7D1',
  black100: '#DCE1E5',
  black50: '#EDEFF2',
  black25: '#F5F6F7',
  black10: '#F9FAFB',
  blackGrey: '#5F5F5F',
  blue: '#0078FF',
  blue25: '#EBF5FF',
  blue100: '#CCE3FF',
  blue50: '#DEEEFF',
  brightBlue: '#EEF6FF',
  brightGrey: '#A4A4A4',
  brightGrey2: '#EBEBEB',
  brightGrey3: '#E7E7E7',
  brightGrey4: '#E6EEF5',
  dark: '#2F2F2F',
  darkBlue: '#0066D9',
  darkBlue2: '#0066FF',
  darkGrey: '#525252',
  darkGrey2: '#44576C',
  danger: '#F03D0C',
  green: '#51B250',
  grey: '#6B6B6B',
  grey2: '#787878',
  grey3: '#505050',
  grey4: '#868686',
  grey5: '#E9ECF3',
  greyBlue: '#F0F5FA',
  greyDisabled: '#ABABAB',
  grey100: '#DCE1E6',
  indigo: '#263747',
  lightBlack: '#373737',
  lightBlue: '#E7EDFD',
  lightBlue2: '#D9EBFF',
  lightRed: '#E84E3C',
  lightGrey: '#D2D2D2',
  lightGrey2: '#D7E2EB',
  lightGrey3: '#D9D9D9',
  lightGrey4: '#E3EAF0',
  lightGrey5: '#F1F1F1',
  lightGrey6: '#F4F4F4',
  lightSilver: '#98A8B9',
  marinBlue: '#3376F6',
  orange: '#FF881A',
  orange2: '#E35141',
  orange3: '#FF9900',
  purple: '#6916E5',
  lightPurple: '#F2E9FE',
  red: '#FF0000',
  red25: '#FFEFE8',
  secondaryOrange: '#FF850A',
  silver: '#C4C4C4',

  white: '#FFFFFF',
  whiteBlue: '#F7FBFF',
  whiteGrey2: '#F5F5F7',
  whiteGrey3: '#FBFBFD',
  whiteGrey4: '#F7F7F7',
  whiteGrey5: '#FAFAFA',
  yellow: '#EBA431',
  transparent: 'transparent',

  shadowBlue: '#7890A0',
  textPrimary: '#0F1317',
  textSecondary: '#667380',
  textBody: '#2C323B',
  uiBorder: '#DCE1E5',
  uiBackground: '#F9FAFB',

  primary: '#0078FF',
  success: '#3AB03F',

  pcsqlBackgroundRed: '#FFE6E6',
  pcsqlTextRed: '#FF434B',
} as const;

export const alphaHex = (alpha: number) => {
  if (Number.isNaN(Number(alpha)) || alpha > 1 || alpha < 0)
    throw new RangeError('Alpha must be a number between 0 and 1');
  return Math.ceil(255 * alpha).toString(16).toUpperCase();
};
